import { render, staticRenderFns } from "./I18nLocaleSelect.vue?vue&type=template&id=cae472f0&scoped=true&lang=pug&"
import script from "./I18nLocaleSelect.vue?vue&type=script&lang=ts&"
export * from "./I18nLocaleSelect.vue?vue&type=script&lang=ts&"
import style0 from "./I18nLocaleSelect.vue?vue&type=style&index=0&id=cae472f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae472f0",
  null
  
)

export default component.exports